import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

const zhCNMessages = {
  "edu.pages.courses.title": "课程库",
  "edu.pages.courses.subtitle": "这里承接管理员课程库与备课主路径：左侧保持稳定业务导航，右侧在课程主面板内切换全部课程、我创建的、我引用的、我克隆的和已共享。",
  "edu.pages.courses.notice": "课程分组属于课程库主面板内部的正式视图切换，不再冒充左侧业务菜单；前端也不再维护本地假分组、本地筛选或伪分页。",
  "edu.pages.courseDetail.title": "课程详情",
  "edu.pages.courseDetail.subtitle": "这里按独立路由读取真实课程详情，并在详情页继续编辑章节、课时与教学任务。",
  "edu.pages.courseDetail.notice": "课程详情页承接 PRD 的“章节 -> 课时 -> 教学任务”备课主路径；保存课程方案会回写源课程方案目录。",
  "edu.pages.courseDetail.messages.invalidCourseId": "当前课程 ID 非法，无法读取课程详情。",
  "edu.pages.courses.scopeSwitcherLabel": "课程视图",
  "edu.pages.courses.scope.all": "全部课程",
  "edu.pages.courses.scope.created": "我创建的",
  "edu.pages.courses.scope.referenced": "我引用的",
  "edu.pages.courses.scope.cloned": "我克隆的",
  "edu.pages.courses.scope.shared": "已共享",
  "edu.pages.courses.actions.continuePreparing": "继续备课",
  "edu.pages.courses.actions.referenceAsset": "引用已有资产",
  "edu.pages.courses.actions.saveMaterial": "保存引用",
  "edu.pages.courses.actions.saveScheme": "保存课程方案",
  "edu.pages.courses.labels.course": "课程",
  "edu.pages.courses.labels.focusItems": "当前关注",
  "edu.pages.courses.labels.libraryBuckets": "课程库分组",
  "edu.pages.courses.labels.currentDetail": "课程详情",
  "edu.pages.courses.labels.scheme": "课程方案",
  "edu.pages.courses.labels.teachingPlans": "教学计划",
  "edu.pages.courses.labels.lessonHours": "课时组织",
  "edu.pages.courses.labels.ksa": "KSA 关联",
  "edu.pages.courses.labels.sectionOverview": "章节 / 课时概览",
  "edu.pages.courses.labels.taskShapes": "教学任务形态",
  "edu.pages.courses.labels.materialSharing": "课程资料共享",
  "edu.pages.courses.labels.nextActions": "下一步入口",
  "edu.pages.courses.labels.sharingScope": "共享范围",
  "edu.pages.courses.messages.emptyMaterials": "暂无课程资料",
  "edu.pages.courses.messages.emptyMaterialsDescription": "当前课程资料继续引用 asset-center 已有资产，不在 edu 内复制文件或单独维护上传生命周期。",
  "edu.pages.courses.messages.scopeAll": "当前视图显示课程库里的全部课程本体，便于管理员先看全量，再按来源或共享语义继续收窄。",
  "edu.pages.courses.messages.scopeCreated": "当前视图只显示我主拥有并继续备课的课程本体。",
  "edu.pages.courses.messages.scopeReferenced": "当前视图只显示沿用共享快照语义的引用课程；后续是否同步仍由老师决定。",
  "edu.pages.courses.messages.scopeCloned": "当前视图只显示已经复制到自己课程库里的课程副本，后续内容演进不再跟源课程联动。",
  "edu.pages.courses.messages.scopeShared": "当前视图只显示已进入共享资源库语义的课程本体，便于继续查看共享状态与后续复用。",
  "edu.pages.courses.messages.createDraft": "当前只先创建真实课程草稿",
  "edu.pages.courses.messages.createDraftDescription": "创建后会同步生成当前课程的默认课程方案骨架；备课、资料引用和教学计划都围绕这门真实课程继续管理。",
  "edu.pages.courses.messages.materialReference": "只引用 asset-center 已有资产",
  "edu.pages.courses.messages.materialReferenceDescription": "这里先手工填写已有资产 ID；edu 只保存教学语境和 asset_id 引用，上传、对象路径、文件生命周期仍由资产中心负责。",
  "edu.pages.courses.messages.schemeSource": "当前编辑的是源课程方案",
  "edu.pages.courses.messages.schemeSourceDescription": "保存后会更新这门课程后续生成的教学计划执行快照；已经创建的教学计划仍读取各自的历史快照，不会被自动改写。",
  "edu.pages.courses.messages.createFailed": "课程创建失败",
  "edu.pages.courses.messages.materialCreateFailed": "课程资料引用失败",
  "edu.pages.courses.messages.schemeSaveFailed": "课程方案保存失败",
  "edu.pages.courses.messages.detailLoadFailed": "课程详情加载失败",
  "edu.pages.courses.placeholders.emptyDetail": "请选择一门课程查看详情。",
  "edu.pages.courses.placeholders.emptyFocusItems": "当前暂无额外关注项。",
  "edu.pages.courses.placeholders.courseTitle": "例如：网络安全基础课",
  "edu.pages.courses.placeholders.courseDescription": "先写下这门课的定位、适用对象或本轮备课说明。",
  "edu.pages.courses.placeholders.assetId": "例如：asset-course-guide-001",
  "edu.pages.courses.placeholders.materialTitle": "例如：课程导图与术语清单",
  "edu.pages.courses.placeholders.resourceType": "PDF / Word / 视频 / 资料",
  "edu.pages.courses.placeholders.visibilityLabel": "课程资料共享",
  "edu.pages.courses.placeholders.scopeId": "课程级资料可留空",
  "edu.pages.courses.placeholders.materialSummary": "说明这份资料适合在哪个学习阶段使用。",
  "edu.pages.courses.placeholders.schemeTitle": "例如：网络安全基础课课程方案",
  "edu.pages.courses.placeholders.ksaInput": "输入或粘贴 KSA key，回车确认",
  "edu.pages.courses.placeholders.schemeSummary": "说明这套课程方案的适用对象、学习目标或备课边界。",
  "edu.pages.courses.forms.titleLabel": "课程名称",
  "edu.pages.courses.forms.descriptionLabel": "课程描述",
  "edu.pages.courses.forms.titleRequired": "请输入课程名称",
  "edu.pages.courses.forms.titleMax": "课程名称不能超过 128 个字符",
  "edu.pages.courses.forms.descriptionMax": "课程描述不能超过 512 个字符",
  "edu.pages.courses.forms.assetIdLabel": "资产 ID",
  "edu.pages.courses.forms.assetIdRequired": "请输入 asset-center 已有资产 ID",
  "edu.pages.courses.forms.assetIdMax": "资产 ID 不能超过 128 个字符",
  "edu.pages.courses.forms.materialTitleLabel": "资料标题",
  "edu.pages.courses.forms.materialTitleRequired": "请输入资料标题",
  "edu.pages.courses.forms.materialTitleMax": "资料标题不能超过 128 个字符",
  "edu.pages.courses.forms.resourceTypeLabel": "资料类型",
  "edu.pages.courses.forms.resourceTypeRequired": "请输入资料类型",
  "edu.pages.courses.forms.resourceTypeMax": "资料类型不能超过 32 个字符",
  "edu.pages.courses.forms.visibilityLabel": "可见范围",
  "edu.pages.courses.forms.visibilityRequired": "请输入可见范围",
  "edu.pages.courses.forms.visibilityMax": "可见范围不能超过 64 个字符",
  "edu.pages.courses.forms.scopeKindLabel": "资料作用域",
  "edu.pages.courses.forms.scopeIdLabel": "作用域内部 ID",
  "edu.pages.courses.forms.summaryLabel": "资料说明",
  "edu.pages.courses.forms.summaryMax": "资料说明不能超过 256 个字符",
  "edu.pages.courses.forms.schemeTitleLabel": "课程方案标题",
  "edu.pages.courses.forms.schemeTitleRequired": "请输入课程方案标题",
  "edu.pages.courses.forms.schemeTitleMax": "课程方案标题不能超过 128 个字符",
  "edu.pages.courses.forms.schemeKsaLabel": "KSA 引用键",
  "edu.pages.courses.forms.schemeSummaryLabel": "方案摘要",
  "edu.pages.courses.forms.schemeSummaryMax": "方案摘要不能超过 512 个字符",
  "edu.pages.courses.forms.chapterTitleLabel": "章节标题",
  "edu.pages.courses.forms.chapterTitleRequired": "请输入章节标题",
  "edu.pages.courses.forms.chapterTitleMax": "章节标题不能超过 128 个字符",
  "edu.pages.courses.forms.chapterTypeLabel": "章节类型",
  "edu.pages.courses.forms.chapterSummaryLabel": "章节说明",
  "edu.pages.courses.forms.chapterSummaryMax": "章节说明不能超过 512 个字符",
  "edu.pages.courses.forms.chapterKsaLabel": "章节 KSA 引用键",
  "edu.pages.courses.forms.lessonTitleLabel": "课时标题",
  "edu.pages.courses.forms.lessonTitleRequired": "请输入课时标题",
  "edu.pages.courses.forms.lessonTitleMax": "课时标题不能超过 128 个字符",
  "edu.pages.courses.forms.lessonTypeLabel": "课时形态",
  "edu.pages.courses.forms.lessonRequiredKindLabel": "必修/选修",
  "edu.pages.courses.forms.lessonStageSummaryLabel": "阶段说明",
  "edu.pages.courses.forms.lessonStageSummaryRequired": "请输入阶段说明",
  "edu.pages.courses.forms.lessonStageSummaryMax": "阶段说明不能超过 128 个字符",
  "edu.pages.courses.forms.lessonUnlockRuleLabel": "解锁规则",
  "edu.pages.courses.forms.lessonUnlockRuleRequired": "请输入解锁规则",
  "edu.pages.courses.forms.lessonUnlockRuleMax": "解锁规则不能超过 128 个字符",
  "edu.pages.courses.forms.lessonKsaLabel": "课时 KSA 引用键",
  "edu.pages.courses.forms.taskTitleLabel": "任务标题",
  "edu.pages.courses.forms.taskTitleRequired": "请输入任务标题",
  "edu.pages.courses.forms.taskTitleMax": "任务标题不能超过 128 个字符",
  "edu.pages.courses.forms.taskTypeLabel": "任务形态",
  "edu.pages.courses.forms.taskStageLabel": "阶段",
  "edu.pages.courses.forms.taskCompletionTemplateLabel": "完成条件模板",
  "edu.pages.courses.forms.taskCompletionTemplateRequired": "请选择完成条件模板",
  "edu.pages.courses.forms.taskThresholdPercentRequired": "请输入观看百分比",
  "edu.pages.courses.forms.taskPassScoreRequired": "请输入通过分数",
  "edu.pages.courses.forms.taskKsaLabel": "任务 KSA 引用键",
  "edu.pages.courses.values.materialTypeDefault": "资料",
  "edu.pages.courses.values.materialVisibilityDefault": "课程资料共享",
  "edu.pages.courses.values.scopeCourse": "课程资料",
  "edu.pages.courses.values.scopeLesson": "课时资料",
  "edu.pages.courses.values.scopeTask": "教学任务资料",
  "edu.pages.courses.labels.schemeStructure": "章节 / 课时 / 教学任务",
  "edu.pages.courses.confirm.deleteChapterTitle": "删除章节",
  "edu.pages.courses.confirm.deleteChapterDescription": "确认删除章节 {index} 吗？其下课时与教学任务会一并移除。",
  "edu.pages.courses.confirm.deleteLessonTitle": "删除课时",
  "edu.pages.courses.confirm.deleteLessonDescription": "确认删除课时 {index} 吗？其下教学任务会一并移除。",
  "edu.pages.courses.confirm.deleteTaskTitle": "删除教学任务",
  "edu.pages.courses.confirm.deleteTaskDescription": "确认删除教学任务 {index} 吗？此操作不会保留当前表单中的任务内容。",
  "edu.pages.courses.modals.materialTitle": "引用已有资产为课程资料",
} satisfies MessageTree;

export const eduCoursesPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": zhCNMessages,
  en: zhCNMessages,
  ja: zhCNMessages,
};
